import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { ExportApi, ExportPrevProjApi } from "./ops";
import { EpidemiologyExportInput, PrevProjExportInput } from "../../utils/formatExportRequest";
import { useUserContext } from "contexts/contextUser";

export function useExportEpidemiologyData() {
  const { accessToken } = useUserContext();
  return useMutation({
    mutationFn: (body: EpidemiologyExportInput) => ExportApi.exportToZip(body, accessToken),
  });
}

export function useExportPrevProjData() {
  const { accessToken } = useUserContext();
  return useMutation({
    mutationFn: (body: PrevProjExportInput) => ExportPrevProjApi.exportToZip(body, accessToken),
  });
}
